@if (productCode) {
  <form [formGroup]="addToCartForm" (submit)="addToCart()" class="add-to-cart__form">
    @if (showQuantity && !hasShopViewUserRole) {
      <div class="add-to-cart__quantity-container">
        @if (!isRestricted) {
          <label class="add-to-cart__quantity-label">{{ "addToCart.quantity" | cxTranslate }}</label>
        }
        @if (hasStock && !isRestricted) {
          <cx-item-counter [control]="addToCartForm.get('quantity')"></cx-item-counter>
        }
        <span class="add-to-cart__wishlist-button">
          <app-uig-add-to-wishlist checkboxStyle="true" [product]="product"></app-uig-add-to-wishlist>
        </span>
      </div>
    }
    @if (hasStock && !isRestricted && !hasShopViewUserRole) {
      <button class="btn btn-secondary btn-block" type="submit"
        [disabled]="quantity <= 0 || quantity > maxQuantity">
        {{ "addToCart.addToCart" | cxTranslate }}
      </button>
    }
  </form>
}
